// Utils
import { useRequiresPermissions } from '@/utils/hooks/middleware/useAccessControl/useRequiresPermission';
import { useRequiresProfile } from '@/utils/hooks/middleware/useAccessControl/useRequiresProfile';
import { useRequiresSpecificPlan } from '@/utils/hooks/middleware/useAccessControl/useRequiresSpecificPlan';
import { useRequiresSubscription } from '@/utils/hooks/middleware/useAccessControl/useRequiresSubscription';

export function useAccessControl() {
    /**
     * Check if the user does not have social profiles activated and the page is not in the list of pages that do not require social profiles
     */
    const requiresProfile = useRequiresProfile();

    /**
     * Check if the user does not have a subscription and the page is not in the list of pages that do not require a subscription
     */
    const requiresSubscription = useRequiresSubscription();

    /**
     * Check if the user does not have permissions to access the page
     */
    const requiresPermissions = useRequiresPermissions();

    /**
     * Check if the user does not have a plan and the page is not in the list of pages that do not require a plan
     */
    const requiresPlan = useRequiresSpecificPlan();

    if (!requiresSubscription.hasAccess) {
        return requiresSubscription;
    }

    if (!requiresProfile.hasAccess) {
        return requiresProfile;
    }

    if (!requiresPermissions.hasAccess) {
        return requiresPermissions;
    }

    if (!requiresPlan.hasAccess) {
        return requiresPlan;
    }

    return { hasAccess: true, redirect_url: null };
}
